export const ENTER = 13;
export const SPACE = 32;
export const ARROW_UP = 38;
export const ARROW_DOWN = 40;
